import DashboardIcon from '@mui/icons-material/Dashboard';
import LinkIcon from '@mui/icons-material/Link';
import PrintIcon from '@mui/icons-material/Print';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { Box, Chip, Grid, Typography } from '@mui/material';
import React from 'react';
import { publicCardSx, publicColors, publicContainerSx, publicH2Sx, publicSectionSx, publicSubtitleSx } from './publicTheme';

const features = [
    {
        icon: DashboardIcon,
        title: 'Dashboard por período',
        description: 'Sucessos, falhas, cancelamentos e peças em andamento em um intervalo de datas — para saber se o mês está saudável.',
        tag: 'Métricas',
    },
    {
        icon: PrintIcon,
        title: 'Jobs e impressoras*',
        description: 'Histórico de impressões, taxa de sucesso por máquina, filamento estimado e integração com firmware.',
        tag: 'Produção',
    },
    {
        icon: ReceiptLongIcon,
        title: 'Vendas e pedidos',
        description: 'Quick checkout*, encomendas e visão do que foi vendido — conectando produção ao que entrou no caixa.',
        tag: 'Vendas',
    },
    {
        icon: LinkIcon,
        title: 'Precificação e custos',
        description: 'Calculadora, materiais e custo de impressora para decidir preço mínimo e margem antes de prometer prazo.',
        tag: 'Decisão',
    },
];

const Advantages = () => (
    <Box id="metricas" component="section" sx={{ ...publicSectionSx, bgcolor: publicColors.surfaceAlt }}>
        <Box sx={publicContainerSx}>
            <Typography component="h2" sx={{ ...publicH2Sx, textAlign: 'center' }}>
                Ferramentas que respondem: “como está minha operação?”
            </Typography>
            <Typography sx={{ ...publicSubtitleSx, textAlign: 'center', mb: 5 }}>
                Estatísticas e módulos pensados para quem precisa decidir com base em volume, retrabalho e margem —
                não só anotar pedidos.
            </Typography>
            <Grid container spacing={3}>
                {features.map(({ icon: Icon, title, description, tag }) => (
                    <Grid item xs={12} sm={6} md={3} key={title}>
                        <Box sx={publicCardSx}>
                            <Chip
                                label={tag}
                                size="small"
                                sx={{
                                    mb: 2,
                                    bgcolor: publicColors.surfaceAlt,
                                    color: publicColors.inkSoft,
                                    fontWeight: 600,
                                    border: `1px solid ${publicColors.border}`,
                                }}
                            />
                            <Icon sx={{ fontSize: 32, color: publicColors.primary, mb: 1.5 }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: publicColors.ink, mb: 1 }}>
                                {title}
                            </Typography>
                            <Typography variant="body2" sx={{ color: publicColors.inkMuted, lineHeight: 1.65 }}>
                                {description}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            <Typography
                variant="caption"
                display="block"
                textAlign="center"
                sx={{ mt: 4, color: publicColors.inkSoft }}
            >
                Recursos marcados com * estão disponíveis apenas para os planos pagos.
            </Typography>
        </Box>
    </Box>
);

export default Advantages;
